import * as Yup from 'yup';

/** @constant {ObjectShape} - Yup Object used for validationScheme in signup procedure */
const AuditGateScheme = Yup.object().shape({
  gatename: Yup.string()
    .required('Name is required')
    .max(80, 'Name can have a maximum of 80 characters'),
});

export { AuditGateScheme };
